import { IContract } from "@rentiohq/shared-frontend/dist/types/contract.types";
import { IProperty } from "@rentiohq/shared-frontend/dist/types/property.types";
import { ResourceList } from "@rentiohq/web-shared/dist/components";
import styled, { spacing } from "@rentiohq/web-theme";
import { ChecklistItem, IChecklistItem } from "../ChecklistItem";

const NegativeMarginWrapper = styled.div`
  margin: 0 -${spacing("loose")};
`;

interface IProps {
  contract: IContract;
  property: IProperty;
  checklistItems: IChecklistItem[];
  extraChecklistItems?: IChecklistItem[];
}

export const ChecklistItems = ({
  contract,
  checklistItems,
  extraChecklistItems,
}: IProps) => {
  return (
    <>
      <NegativeMarginWrapper>
        <ResourceList
          renderItem={(item: IChecklistItem) => (
            <ChecklistItem item={item} contract={contract} />
          )}
          items={checklistItems}
          hasSeparator={false}
        />
      </NegativeMarginWrapper>

      {extraChecklistItems && extraChecklistItems.length > 0 && (
        <NegativeMarginWrapper>
          <ResourceList
            renderItem={(item: IChecklistItem) => (
              <ChecklistItem item={item} contract={contract} />
            )}
            items={extraChecklistItems}
            hasSeparator={false}
          />
        </NegativeMarginWrapper>
      )}
    </>
  );
};
